<script>
    import CartFastContent from "../cart/CartFastContent";
    import HeaderCart from "./HeaderCart";

    export default {
        el: '#header-cart-drawer',

        name: "CartFastDrawer",

        extends: HeaderCart,

        components: {
            'cart-fast-content': CartFastContent
        },
    }
</script>